import React, { FC } from "react";
import { Box } from "@mui/material";
import { IDeviceInstance } from "common/store/ProjectStore";
import ShowDevice from "./ShowDevice";

interface IProps {
  gateway: IDeviceInstance | null;
  devices: IDeviceInstance[];
  plotImageTransform: number;
}

const ShowNetwork: FC<IProps> = (props) => {
  const { gateway, devices, plotImageTransform } = props;

  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        position: "absolute",
        bgcolor: "transparent",
        zIndex: 3,
        height: "100%",
        width: "100%",
        pointerEvents: "none",
      }}
    >
      {gateway !== null && <ShowDevice device={gateway} plotImageTransform={plotImageTransform}/>}
      {devices.length > 0 &&
        devices.map((dev, index) => (
          <ShowDevice key={index} device={dev} plotImageTransform={plotImageTransform}/>
        ))}
    </Box>
  );
};

export default ShowNetwork;
